
export const SORT_BY = {
  name: 'display_name',
  profit: 'summary.profit',
  createdAt: 'created_at'
};

export const TABLE_HEADER = [
  { title: '' },
  { title: 'Name & details', sortByKey: SORT_BY.name },
  { title: 'Order Type' },
  { title: 'Instruments', },
  { title: 'Created At', sortByKey: SORT_BY.createdAt },
  { title: 'Status' }
];

export const VIEW_TYPE = {
  list: 'list',
  grid: 'grid'
};

export const DESKTOP_WIDTH = 1024;

export const showByOption = [
  { displayName: 'Running Strategies', value: 'running_live_runs' },
  // { displayName: 'Oneclick/Automatic', value: 'actual_live_runs' },
  // { displayName: 'Paper', value: 'paper' },
  { displayName: 'Backtest', value: 'historic' },
  { displayName: 'All', value: 'all' }
];
